import { render, staticRenderFns } from "./pdfRead.vue?vue&type=template&id=50983871&scoped=true&"
import script from "./pdfRead.vue?vue&type=script&lang=js&"
export * from "./pdfRead.vue?vue&type=script&lang=js&"
import style0 from "./pdfRead.vue?vue&type=style&index=0&id=50983871&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50983871",
  null
  
)

export default component.exports